import PatronService from '@/services/PatronService'

export default {
	namespaced: true,
	state: {
		loginStatus: 'idle',
		loggedIn: false,
		sessionToken: null,
		patronKey: '',
		name: '',
		borrowingHistory: {
			data: [ ]
		},
		barcodeSearch: [ ],
		barcodeSearchStatus: 'idle',
		collections: { }
	},
	getters: {
		name( state, getters ) {
			var name = {
				surname: '',
				given: ''
			};
			// mangle name to get surname and given name
			// split it, [0] is surname; [1] is given name
			// need to clean up each part, so only keep what is up to the first (
			var nameParts = state.name.split( ', ' );
			// deal with the surname
			name.surname = nameParts[ 0 ].split( '(' )[ 0 ].trim( );
			// deal with given name
			if ( nameParts.length == 2 ) {
				// we have a given name
				name.given = nameParts[ 1 ].split( '(' )[ 0 ].trim( );
			}
			return name;
		},
		borrowingHistory( state, getters ) {
			return state.borrowingHistory.data;
		},
		borrowingHistoryCount( state, getters ) {
			return getters.borrowingHistory.length;
		},
		barcodeSearch( state, getters ) {
			return state.barcodeSearch;
		},
		barcodeSearchCount( state, getters ) {
			return getters.barcodeSearch.length;
		},
		barcodeSearchStatus( state, getters ) {
			return state.barcodeSearchStatus;
		},
		loginStatus( state, getters ) {
			return state.loginStatus;
		},
		collections( state, getters ) {
			return state.collections;
		},

	},
	mutations: {
		login( state, data ) {
			state.sessionToken = data.sessionToken;
			state.name = data.name;
			state.patronKey = data.patronKey;
			state.loggedIn = true;
		},
		logout( state, data ) {
			state.loggedIn = false;
			state.sessionToken = null;
			state.patronKey = '';
			state.name = '';
			state.borrowingHistory = {
				data: [ ]
			};
			state.barcodeSearch = [ ];
			state.collections = { };
		},
		setBorrowingHistory( state, data ) {
			state.borrowingHistory.data = data;
		},
		addBarcodeSearch( state, data ) {
			state.barcodeSearch.unshift( data );
		},
		setBarcodeSearchStatus( state, data ) {
			state.barcodeSearchStatus = data;
		},
		setLoginStatus( state, data ) {
			state.loginStatus = data;
		},
		setCollections( state, data ) {
			state.collections = data;
		}
	},
	actions: {
		login( context, payload ) {
			context.dispatch( 'error/hide', null, { root: true } );
			context.dispatch( 'loading/show', { message: 'Logging in', caller: 'patron/login' }, { root: true } );
			context.commit( 'setLoginStatus', 'started' );

			PatronService.login( payload )
				.then( ( response ) => {
//					console.log( response.data );
					context.commit( 'login', response.data );
					context.commit( 'setLoginStatus', 'done' );
					context.dispatch( 'updateCollections' );
				} )
				.catch( ( error ) => {
					var errorMessage = 'Something went wrong';
					if ( error.response ) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log( error.response.data );
						console.log( error.response.status );
						console.log( error.response.headers );
						if ( error.response.status == 401 ) {
							errorMessage = 'Invalid Library Card or PIN number';
						} else {
							errorMessage = 'Server returned: ' + error.response.status + ' => ' + JSON.stringify( error.response.data );
						}
					} else if ( error.request ) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
//						console.log( error.request );
						errorMessage = 'No response from server';
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log( 'Error', error.message );
					}
//					console.log( error.config );

					context.dispatch( 'error/show', errorMessage, { root: true } );
					context.commit( 'setLoginStatus', 'error' );
				} )
				.finally( ( ) => {
					context.dispatch( 'loading/hide', { caller: 'patron/login' }, { root: true } );
					context.commit( 'setLoginStatus', 'idle' );
				} );
		},
		logout( context, payload ) {
			context.dispatch( 'error/hide', null, { root: true } );
			context.dispatch( 'loading/show', { message: 'Logging out' }, { root: true } );

			PatronService.logout( )
				.then( ( response ) => {
					context.commit( 'logout', response.data );
				} )
				.catch( ( error ) => {
					var errorMessage = 'Something went wrong';
					if ( error.response ) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log( error.response.data );
						console.log( error.response.status );
						console.log( error.response.headers );
						errorMessage = 'Server returned: ' + error.response.status + ' => ' + JSON.stringify( error.response.data );
					} else if ( error.request ) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
//						console.log( error.request );
						errorMessage = 'No response from server';
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log( 'Error', error.message );
					}
//					console.log( error.config );

					context.dispatch( 'error/show', errorMessage, { root: true } );
				} )
				.finally( ( ) => {
					context.dispatch( 'loading/hide', null, { root: true } );
				} );
		},
		updateBorrowingHistory( context, payload ) {
			context.dispatch( 'error/hide', null, { root: true } );
			context.dispatch( 'loading/show', { message: 'Retrieving items borrowed', caller: 'patron/updateBorrowingHistory' }, { root: true } );

			PatronService.getCircHistory( )
				.then( ( response ) => {
					var data = [ ];
					// need to really mangle the data to make is usable
					// for each circHistoryRecord in response.data.fields.circHistoryRecordList
					response.data.fields.circHistoryRecordList.forEach( function( circHistoryRecord ) {
						var item = {
							checkOutDate: new Date( circHistoryRecord.fields.checkOutDate ),
							bibId: circHistoryRecord.fields.bib != null ? circHistoryRecord.fields.bib.key : '',
							title: circHistoryRecord.fields.title != null ? circHistoryRecord.fields.title : '',
							author: circHistoryRecord.fields.author != null ? circHistoryRecord.fields.author : '',
							collection: circHistoryRecord.fields.item != null ? circHistoryRecord.fields.item.fields.collection.key : ''
						};
						if ( item.title != '' ) {
							data.push( item );
						}
					} );
					context.commit( 'setBorrowingHistory', data );
				} )
				.catch( ( error ) => {
					var errorMessage = 'Something went wrong';
					if ( error.response ) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log( error.response.data );
						console.log( error.response.status );
						console.log( error.response.headers );
						errorMessage = 'Server returned: ' + error.response.status + ' => ' + JSON.stringify( error.response.data );
					} else if ( error.request ) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
//						console.log( error.request );
						errorMessage = 'No response from server';
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log( 'Error', error.message );
					}
//					console.log( error.config );

					context.dispatch( 'error/show', errorMessage, { root: true } );
				} )
				.finally( ( ) => {
					context.dispatch( 'loading/hide', { caller: 'patron/updateBorrowingHistory' }, { root: true } );
				} );
		},


		barcodeSearch( context, payload ) {
			context.dispatch( 'error/hide', null, { root: true } );
			context.dispatch( 'loading/show', { message: 'Looking up barcode' }, { root: true } );
			context.commit( 'setBarcodeSearchStatus', 'started' );

			PatronService.getBarcodeInfo( payload )
				.then( ( response ) => {
					// need to really mangle the data to make is usable
					var data = {
						barcode: response.data.fields.barcode,
						title: response.data.fields.bib.fields.title,
						author: response.data.fields.bib.fields.author,
						bibId: response.data.fields.bib.key,
						collection: response.data.fields.collection.key,
						borrowed: false,
						color: 'error'
					};

					var found = context.getters.borrowingHistory.filter( item => {
						return item.bibId == data.bibId;
					} );

					if ( found.length > 0 ) {
						data.borrowed = found.length;
						data.color = 'success';
					}

					context.commit( 'addBarcodeSearch', data );
					context.commit( 'setBarcodeSearchStatus', 'done' );
				} )
				.catch( ( error ) => {
					var errorMessage = 'Something went wrong';
					if ( error.response ) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log( error.response.data );
						console.log( error.response.status );
						console.log( error.response.headers );
						if ( error.response.status == 404 ) {
							errorMessage = 'Barcode not found';
						} else {
							errorMessage = 'Server returned: ' + error.response.status + ' => ' + JSON.stringify( error.response.data );
						}
					} else if ( error.request ) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
//						console.log( error.request );
						errorMessage = 'No response from server';
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log( 'Error', error.message );
					}
//					console.log( error.config );

					context.dispatch( 'error/show', errorMessage, { root: true } );
					context.commit( 'setBarcodeSearchStatus', 'error' );
				} )
				.finally( ( ) => {
					context.dispatch( 'loading/hide', null, { root: true } );
					context.commit( 'setBarcodeSearchStatus', 'idle' );
				} );
		},


		updateCollections( context, payload ) {
			context.dispatch( 'error/hide', null, { root: true } );
			context.dispatch( 'loading/show', { message: 'Retrieving collections', caller: 'patron/updateCollections' }, { root: true } );

			PatronService.getCollectionInfo( )
				.then( ( response ) => {
					var data = { };
					// need to really mangle the data to make is usable
					// for each circHistoryRecord in response.data.fields.circHistoryRecordList
					response.data.forEach( function( collectionRecord ) {
						var item = {
							code: collectionRecord.key,
							description: collectionRecord.fields.pacDescription,
							cost: collectionRecord.fields.averageReplacementCost / 100
						};
						data[ collectionRecord.key ] = item ;
					} );
					context.commit( 'setCollections', data );
				} )
				.catch( ( error ) => {
					var errorMessage = 'Something went wrong';
					if ( error.response ) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log( error.response.data );
						console.log( error.response.status );
						console.log( error.response.headers );
						errorMessage = 'Server returned: ' + error.response.status + ' => ' + JSON.stringify( error.response.data );
					} else if ( error.request ) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
//						console.log( error.request );
						errorMessage = 'No response from server';
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log( 'Error', error.message );
					}
//					console.log( error.config );

					context.dispatch( 'error/show', errorMessage, { root: true } );
				} )
				.finally( ( ) => {
					context.dispatch( 'loading/hide', { caller: 'patron/updateCollections' }, { root: true } );
				} );
		},
	}
}